export const baseURL =
  process.env.URL ??
  (typeof window !== 'undefined' ? window.location.origin : undefined) ??
  'https://www.productioncrate.com'

// Add feature flags here
export const features = {
  favorites: false, // TODO: Get from env
  pushNotifications: parseBoolean(process.env.NEXT_PUBLIC_FEATURE_PUSH_NOTIFICATIONS, false),
  vfxEnhancedPreviews: parseBoolean(process.env.NEXT_PUBLIC_FEATURE_VFX_ENHANCED_PREVIEWS, true),
}

export const CRATE_CORE_API_BASE_URL =
  process.env.NEXT_PUBLIC_CRATE_CORE_API_BASE_URL || 'https://rest.productioncrate.com'

export const CRATE_USERS_BASE_URL = process.env.NEXT_PUBLIC_CRATE_USERS_BASE_URL || 'https://user.productioncrate.com'

export const LEGACY_API_BASE_URL =
  process.env.NEXT_PUBLIC_LEGACY_API_BASE_URL || 'https://d30upb8d426d8z.cloudfront.net'

export const SESSION_TOKEN_COOKIE_KEY = process.env.NEXT_PUBLIC_SESSION_TOKEN_COOKIE_KEY || 'newLogin'
export const REFRESH_TOKEN_COOKIE_KEY = process.env.NEXT_PUBLIC_REFRESH_TOKEN_COOKIE_KEY || 'newLogin_refresh'
export const SESSION_TOKEN_LOCAL_STORAGE_KEY = process.env.NEXT_PUBLIC_SESSION_TOKEN_LOCAL_STORAGE_KEY || 'token'
export const REFRESH_TOKEN_LOCAL_STORAGE_KEY =
  process.env.NEXT_PUBLIC_REFRESH_TOKEN_LOCAL_STORAGE_KEY || 'refresh_token'

export const DEFAULT_TITLE = 'ProductionCrate - Make it Awesome.'
export const DEFAULT_DESCRIPTION =
  "Video Production Elements - Download exclusive video resources & spend less time in post. 1000's Of Original Production Elements, VFX, Original Music & More. Go PRO Now! 14-Day Free Trial. Download Our Mobile App. View Pricing Details. End-To-End Solutions. Request A Demo."
export const DEFAULT_IMAGE = `${baseURL}/img/ProductionCrate_Share_Graphic_FootageCrate_NoText.jpg`

export const MIN_HEADER_HEIGHT = 125

// When browsing multi-content assets, this sets the limit for each content
export const MULTI_CONTENT_ASSETS_LIMIT: number | undefined = process.env.MULTI_CONTENT_ASSETS_LIMIT
  ? parseInt(process.env.MULTI_CONTENT_ASSETS_LIMIT)
  : undefined

export const MEILISEARCH_HOST = process.env.NEXT_PUBLIC_MEILISEARCH_HOST || 'https://search.k8s.productioncrate.com'
export const MEILISEARCH_API_KEY = process.env.NEXT_PUBLIC_MEILISEARCH_API_KEY || ''
export const MEILISEARCH_ASSETS_INDEX = process.env.NEXT_PUBLIC_MEILISEARCH_ASSETS_INDEX || 'assets'

export const SITE_MAP_DOMAIN_VFX = process.env.SITE_MAP_DOMAIN_VFX || 'footagecrate.com'
export const SITE_MAP_DOMAIN_SFX = process.env.SITE_MAP_DOMAIN_SFX || 'soundscrate.com'
export const SITE_MAP_DOMAIN_GRAPHICS = process.env.SITE_MAP_DOMAIN_GRAPHICS || 'graphicscrate.com'
export const SITE_MAP_DOMAIN_3D = process.env.SITE_MAP_DOMAIN_3D || 'rendercrate.com'

export const BUILD_DATE = process.env.NEXT_PUBLIC_BUILD_DATE || new Date().toISOString()

export const SUBREQUEST_LIMIT = process.env.NEXT_PUBLIC_SUBREQUESTS_LIMIT
  ? parseInt(process.env.NEXT_PUBLIC_SUBREQUESTS_LIMIT)
  : undefined

export const DEFAULT_SEARCH_CATEGORY = process.env.NEXT_PUBLIC_DEFAULT_SEARCH_CATEGORY || 'all'

export const ASSETS_GRID_SCROLLER_ID = 'assets-grid-scroller'

export const HOVER_OTHERS_DIMMING_TIMEOUT = 1300

export const COURSES_LESSON_COMPLETED_PROGRESS = 75 // Keep in sync with the backend value

export const CRATE_LOGIN_URL = process.env.NEXT_PUBLIC_CRATE_LOGIN_URL || `${CRATE_USERS_BASE_URL}/login`

export const DOWNLOAD_HOST = process.env.NEXT_PUBLIC_DOWNLOAD_HOST || baseURL

export const FALLBACK_TO_LOCAL_STORAGE = parseBoolean(process.env.NEXT_PUBLIC_FALLBACK_TO_LOCAL_STORAGE, false)

export const ONESIGNAL_APP_ID = process.env.NEXT_PUBLIC_ONESIGNAL_APP_ID || ''

export const ATTRIBUTION_ENABLED = parseBoolean(process.env.NEXT_PUBLIC_ATTRIBUTION_ENABLED, false)

// Categories loading configuration
export const CATEGORIES_BUNDLED = parseBoolean(process.env.NEXT_PUBLIC_CATEGORIES_BUNDLED, true)
export const CATEGORIES_JSON_URL =
  process.env.NEXT_PUBLIC_CATEGORIES_JSON_URL || 'https://public.productioncrate.com/metadata/categories.json'

/**
 * Parse a value to boolean
 * @param value
 * @param defaultValue
 */
export function parseBoolean(value: unknown, defaultValue = false): boolean {
  if (typeof value === 'boolean') return value
  if (value === undefined || value === null || value === '') return defaultValue
  const v = String(value).trim().toLowerCase()
  if (['1', 'true', 'yes', 'y', 'on'].includes(v)) return true
  if (['0', 'false', 'no', 'n', 'off'].includes(v)) return false
  return defaultValue
}
